<template>
  <div id="pageEditProfile" class="contact-page page-home desk-frame">
    <header-desktop @saveProfile="saveProfile" :isLoadingProfile="isLoading" />
    <menu-desktop />
    <!-- Head -->
    <section
      class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    >
      <div class="title">עריכת פרופיל</div>

      <router-link to="/profile" class="m_bt_head head_cancel">
        ביטול
      </router-link>

      <a
        href="javascript:void(0)"
        @click.prevent="saveProfile"
        class="m_bt_head head_save"
      >
        <span v-show="!isLoading"> שמירה </span>
        <vue-loaders-ball-clip-rotate
          v-show="isLoading"
          color="white"
          scale="0.8"
          style="position: relative;top: 6px;"
        ></vue-loaders-ball-clip-rotate>
      </a>
    </section>

    <!-- Info -->
    <section class="profile-hello text center no_mobile">
      <b class="bold">רופא/ה יקר/ה,</b>
      <br class="mobile_only" />
      פרופיל הרופא מוצג באתר האינטרנט של ביה"ח ומשמש את הגולשים לקבלת מידע
      אודותיך. ניתן לעדכן מידע חדש או לערוך מידע קיים ככל הנדרש.
    </section>

    <div v-show="user?.first_name" class="profile-container">
      <!-- Hero -->
      <section class="profile-hero bg--blue center tx--white">
        <div class="profile-image-wrap inline relative">
          <div class="profile-image relative">
            <img :src="user.image" />
            <div
              v-if="user.updateAvatarRequestExists"
              class="profile-image-overlay"
            >
              <img src="assets/img/svg/ok-white.svg" />
              בקשה לתיאום <br />צילום נשלחה
            </div>
          </div>
          <!--/profile-image-->
        </div>
        <!--/profile-image-wrap-->
        <div
          class="ask-photo flex flex--content--center tx--under no_mobile pointer"
          @click="openRequestPhotoPopup"
        >
          <img src="assets/img/svg/camera.svg" />
          תיאום צילום תמונה חדשה
        </div>
        <h1 class="title bold tx--white no-marge">
          {{ user.staticTitle }} {{ user.first_name }} {{ user.last_name }}
        </h1>
        <div class="text tx--white">{{ user.job }}</div>
        <a
          href="javascript:void(0)"
          class="profile-edit-bt flex flex--content--center tx--under tx--white"
          @click="openRequestPhotoPopup"
        >
          <img src="assets/img/svg/date-white.svg" />
          תיאום צילום תמונה חדשה
        </a>
      </section>

      <!-- Page -->
      <section class="inner-edit-pgae inner-profile-container">
        <!-- title -->
        <div class="box-edit">
          <div class="box-edit-title">תואר</div>
          <input type="text" v-model.trim="user.title" />
        </div>

        <!-- Job -->
        <!-- <div class="box-edit">
          <div class="box-edit-title">מומחיות</div>
          <input type="text" v-model.trim="user.job" />
        </div> -->

        <!-- About -->
        <div
          ref="profile-about"
          class="box-edit"
          :class="{ 'box-edit-error': errors.about }"
        >
          <div class="box-edit-title flex">
            קצת עלי
            <span class="error-message" v-if="errors.about">
              שדה חובה
            </span>
          </div>
          <textarea v-model.trim="user.about"> </textarea>
        </div>

        <!-- Languages -->
        <div
          ref="profile-languages"
          class="box-edit"
          :class="{ 'box-edit-error': errors.languages }"
        >
          <div class="box-edit-title flex">
            שפות
            <span class="error-message" v-if="errors.languages">
              שדה חובה
            </span>
          </div>
          <div class="choose-languages flex">
            <div
              class="form_check form_check-blue"
              v-for="lang in defaultLangs"
              :key="lang"
            >
              <label>
                <input
                  type="checkbox"
                  :checked="user.languages.includes(lang)"
                  @change="onLang(lang)"
                />
                {{ lang }}
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <template v-for="(lang, i) in user.languages">
            <div
              v-if="!defaultLangs.includes(lang)"
              class="add_new_row"
              :key="i"
            >
              <textarea v-model.trim="user.languages[i]"></textarea>
            </div>
          </template>
          <!--/choose-languages-->
          <div class="hold-rows">
            <div class="add_new_row add_new_lang_row" style="display: none;">
              <input type="text" placeholder="הוספת שפה" />
              <button class="bt_blue" type="button">+ הוסף</button>
            </div>
          </div>
          <div
            class="add_task_width add_new_task flex flex--start"
            @click="addRow(user.languages)"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת שפה
          </div>
        </div>

        <!-- Roles -->
        <div class="box-edit">
          <div class="box-edit-title">תפקידים</div>
          <div class="add_new_row" v-for="(role, i) in user.roles" :key="i">
            <textarea v-model.trim="user.roles[i]"></textarea>
          </div>
          <div
            @click="addRow(user.roles)"
            class="add_task_width add_new_task flex flex--start"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת רשומה
          </div>
        </div>

        <!-- Clinical experience -->
        <div class="box-edit">
          <div class="box-edit-title">ניסיון קליני</div>
          <div
            class="add_new_row"
            v-for="(exp, i) in user.clinical_exp"
            :key="i"
          >
            <textarea v-model.trim="user.clinical_exp[i]"></textarea>
          </div>
          <div
            @click="addRow(user.clinical_exp)"
            class="add_task_width add_new_task flex flex--start"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת רשומה
          </div>
        </div>

        <!-- Education -->
        <div class="box-edit">
          <div class="box-edit-title">השכלה</div>
          <div class="add_new_row" v-for="(edu, i) in user.education" :key="i">
            <textarea v-model.trim="user.education[i]"></textarea>
          </div>
          <div
            @click="addRow(user.education)"
            class="add_task_width add_new_task flex flex--start"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת רשומה
          </div>
        </div>

        <!-- Courses -->
        <div class="box-edit">
          <div class="box-edit-title">השתלמויות</div>
          <div class="add_new_row" v-for="(course, i) in user.courses" :key="i">
            <textarea v-model.trim="user.courses[i]"></textarea>
          </div>
          <div
            @click="addRow(user.courses)"
            class="add_task_width add_new_task flex flex--start"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת רשומה
          </div>
        </div>

        <!-- Membership -->
        <div class="box-edit">
          <div class="box-edit-title">חברות באיגודים מקצועיים</div>
          <div class="add_new_row" v-for="(ms, i) in user.memberships" :key="i">
            <textarea v-model.trim="user.memberships[i]"></textarea>
          </div>
          <div
            @click="addRow(user.memberships)"
            class="add_task_width add_new_task flex flex--start"
          >
            <span class="plus-circ flex flex--content--center">
              <span class="plus"></span>
            </span>
            הוספת רשומה
          </div>
        </div>

        <a
          href="javascript:void(0)"
          @click.prevent="saveProfile"
          class="bt_blue full-width mobile_only"
        >
          <span v-show="!isLoading">
            שמירה
          </span>
          <vue-loaders-ball-clip-rotate
            v-show="isLoading"
            color="white"
            scale="0.8"
            style="position: relative;top: 6px;"
          ></vue-loaders-ball-clip-rotate>
        </a>
        <!--bottom-->
        <div class="inner-profile-bottom no_mobile">
          <button class="bt_blue-rounded" @click.prevent="saveProfile">
            <span v-show="!isLoading">
              <img width="21" src="assets/img/svg/saved-white.svg" />
              שמירה
            </span>
            <vue-loaders-ball-clip-rotate
              v-show="isLoading"
              color="white"
              scale="0.8"
            ></vue-loaders-ball-clip-rotate>
          </button>
        </div>
        <!--/bottom-->
      </section>
    </div>
  </div>
</template>

<script>
import {
  requestUpdateUserDetails,
  requestUpdateUserAvatar
} from "../api/api-quatro";
import { mapActions, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import ConfirmEditProfile from "@/components/Popups/ConfirmEditProfile";
import EditProfilePhotoRequest from "@/components/Popups/EditProfilePhotoRequest";
import HeaderDesktop from "@/components/Shared/HeaderDesktop.vue";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";

export default {
  name: "ProfileEdit",
  components: { HeaderDesktop, MenuDesktop },
  data() {
    return {
      /// Data
      isLoading: false,
      defaultLangs: ["עברית", "אנגלית", "ערבית", "רוסית", "צרפתית", "ספרדית"],
      defaultUser: null,

      /// Form data
      user: {
        title: "",
        staticTitle: "",
        first_name: "",
        last_name: "",
        image: "",
        about: "",
        job: "",
        roles: [],
        clinical_exp: [],
        education: [],
        courses: [],
        memberships: [],
        languages: []
      },

      errors: {
        about: false,
        languages: false
      }
    };
  },
  methods: {
    ...mapActions(["GET_USER_PROFILE"]),
    ...mapMutations(["UPDATE_USER_PROFILE"]),
    /**
     * Opens a popup for request new
     * avatar image change.
     */
    openRequestPhotoPopup() {
      if (this.isLoading) return;
      this.$modal.show(EditProfilePhotoRequest, {
        isRequestExists: this.user.updateAvatarRequestExists,
        func: this.requestUpdateAvatar
      });
    },
    /**
     * Sending request to change avatar.
     */
    async requestUpdateAvatar() {
      if (this.user.updateAvatarRequestExists || this.isLoading) return;

      try {
        const res = await requestUpdateUserAvatar(this.user.license);
        if (res["status"] !== "success") {
          this.$modal.show(Error, {
            title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
          });
          return;
        }

        this.UPDATE_USER_PROFILE({ updateAvatarRequestExists: true });
      } catch (error) {
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
        console.log(error);
      }
    },
    /**
     * Adding row to an array so the user could
     * add another row of info into his profile.
     *
     * Uses in cases like "clinical_exp", "education"
     * and more.
     *
     * @param {Array} array
     */
    addRow(array) {
      const lastChild = array[array.length - 1];
      if (array.length && (lastChild === "" || lastChild.trim() === "")) return;
      array.push("");
    },
    /**
     * Sending the form to the server.
     * Deleting all the rows with no content.
     */
    async saveProfile() {
      if (this.isLoading) return;

      const isValid = this.errorsHandler();
      if (!isValid) return;

      this.isLoading = true;

      const fieldsToClean = [
        "roles",
        "clinical_exp",
        "education",
        "courses",
        "languages",
        "memberships"
      ];

      // Clean user fields by removing empty strings
      fieldsToClean.forEach(field => {
        this.user[field] = this.user[field].filter(item => item.trim() !== "");
      });

      const body = Object.keys(this.user).reduce((acc, key) => {
        if (
          JSON.stringify(this.user[key]) !==
          JSON.stringify(this.defaultUser[key])
        ) {
          acc[key] = this.user[key];
        }
        return acc;
      }, {});
      // const body = {
      //   title: this.user.title,
      //   first_name: this.user.first_name,
      //   last_name: this.user.last_name,
      //   image: this.user.image,
      //   about: this.user.about,
      //   job: this.user.job,
      //   roles: this.user.roles,
      //   clinical_exp: this.user.clinical_exp,
      //   education: this.user.education,
      //   courses: this.user.courses,
      //   memberships: this.user.memberships
      // };

      try {
        const res = await requestUpdateUserDetails(this.user.license, body);
        if (res["status"] === "success") {
          this.$modal.show(ConfirmEditProfile);
          this.UPDATE_USER_PROFILE({ updateRequestExists: true });
          this.$router.push("/profile");
        } else {
          this.$modal.show(Error, {
            title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
          });
        }
      } catch (error) {
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    onLang(lang) {
      const index = this.user.languages.indexOf(lang);
      if (index === -1) this.user.languages.push(lang);
      else this.user.languages.splice(index, 1);
    },
    errorsHandler() {
      this.errors.about = this.user.about.trim() === "";
      this.errors.languages = this.user.languages.length === 0;

      let elementScroll = "";
      if (this.errors.about) elementScroll = "profile-about";
      else if (this.errors.languages) elementScroll = "profile-languages";

      if (elementScroll) {
        const element = this.$refs[elementScroll];
        if (element && element.offsetTop) {
          setTimeout(() => {
            window.scrollTo({
              top: element.offsetTop,
              left: 0,
              behavior: "smooth"
            });
            elementScroll = "";
          }, 100);
        }
        return false;
      }
      return true;
    }
  },
  async created() {
    this.user = await this.GET_USER_PROFILE();
    if (!this.user.languages) this.user.languages = [];
    this.defaultUser = JSON.parse(JSON.stringify(this.user));
    if (this.user.updateRequestExists) {
      this.$router.replace("/profile");
    }
  }
};
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
